var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasZipSpec)?_c('zip-package-requirement',{attrs:{"spec":_vm.zipPackageSpec,"asset-type":_vm.assetType}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }